"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var button_1 = __importDefault(require("relements/build/esm/ui/button"));
var icon_1 = __importDefault(require("relements/build/esm/ui/icon"));
var download_svg_1 = __importDefault(require("../../icons/download.svg"));
require("./DownloadGlossary.scss");
var defaults = {
    onClick: function () { return null; },
};
/**
 * Download the requested file onClick
 * @param Props
 * @component
 */
var DownloadGlossary = function (_a) {
    var onClick = (_a === void 0 ? defaults : _a).onClick;
    return (react_1["default"].createElement("div", { className: "downloadGlossary" },
        react_1["default"].createElement(icon_1["default"], { src: download_svg_1["default"], className: 'icon' }),
        react_1["default"].createElement(button_1["default"], { className: "downloadBtn", type: button_1["default"].TYPES.OUTLINE, onClick: onClick }, "Download current glossary")));
};
exports["default"] = DownloadGlossary;
